import { Column, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn } from "typeorm";
import { EnquiriesEntity } from "./enquiries";

@Entity("enquiry_pack_bom")
export class EnquiryPackBomEntity {
    @PrimaryGeneratedColumn('increment',{
        name:"id"
    }) 
    id: number;

    @Column('int',{
        name:'item_category_id',
        nullable:false
    })
    itemCategoryId: number

    @Column('int',{
        name:'item_sub_category_id',
        nullable:false
    })
    itemSubCategoryId: number

    @Column('int',{
        name:'item_id',
        nullable:false
    })
    itemId: number

    @Column('decimal',{
        name:'quantity',
        precision:15,
        scale:3,
        nullable:false
    })
    quantity: number

    // @ManyToOne(() => EnquiriesEntity,enquiries =>enquiries.enquiryPackInfo,{nullable: false} )
    // @JoinColumn({name:'enquiry_id'})
    // enquiryEntity:EnquiriesEntity
}